/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Columns_DeltaInputs */

const id_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan ukuran`)
};

const ms_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan saiz`)
};

const da_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Størrelsesændring`)
};

const de_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größenänderung`)
};

const en_us2_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size change`)
};

const es_es2_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de tamaño`)
};

const es_mx2_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de tamaño`)
};

const fil_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbabago sa laki`)
};

const fr_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variation de taille`)
};

const it_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variazione dimensione`)
};

const hu_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Méretváltozás`)
};

const nl_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groottewijziging`)
};

const no_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Størrelsesendring`)
};

const pl_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana rozmiaru`)
};

const pt_br2_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração de tamanho`)
};

const pt_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração de tamanho`)
};

const ro_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificarea dimensiunii`)
};

const fi_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koon muutos`)
};

const sv_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storleksändring`)
};

const vi_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi kích thước`)
};

const tr_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boyut değişikliği`)
};

const cs_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna velikosti`)
};

const bg_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промяна в размера`)
};

const ru_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера`)
};

const uk_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміна розміру`)
};

const ar_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم`)
};

const hi_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आकार में बदलाव`)
};

const th_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงขนาด`)
};

const ja_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズの変化`)
};

const zh_cn2_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大小变化`)
};

const zh_hant1_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大小變更`)
};

const ko_builds_comparison_columns_delta = /** @type {(inputs: Builds_Comparison_Columns_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기 변경`)
};

/**
* | output |
* | --- |
* | "Size change" |
*
* @param {Builds_Comparison_Columns_DeltaInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_columns_delta = /** @type {((inputs?: Builds_Comparison_Columns_DeltaInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Columns_DeltaInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_columns_delta(inputs)
	if (locale === "ms") return ms_builds_comparison_columns_delta(inputs)
	if (locale === "da") return da_builds_comparison_columns_delta(inputs)
	if (locale === "de") return de_builds_comparison_columns_delta(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_columns_delta(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_columns_delta(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_columns_delta(inputs)
	if (locale === "fil") return fil_builds_comparison_columns_delta(inputs)
	if (locale === "fr") return fr_builds_comparison_columns_delta(inputs)
	if (locale === "it") return it_builds_comparison_columns_delta(inputs)
	if (locale === "hu") return hu_builds_comparison_columns_delta(inputs)
	if (locale === "nl") return nl_builds_comparison_columns_delta(inputs)
	if (locale === "no") return no_builds_comparison_columns_delta(inputs)
	if (locale === "pl") return pl_builds_comparison_columns_delta(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_columns_delta(inputs)
	if (locale === "pt") return pt_builds_comparison_columns_delta(inputs)
	if (locale === "ro") return ro_builds_comparison_columns_delta(inputs)
	if (locale === "fi") return fi_builds_comparison_columns_delta(inputs)
	if (locale === "sv") return sv_builds_comparison_columns_delta(inputs)
	if (locale === "vi") return vi_builds_comparison_columns_delta(inputs)
	if (locale === "tr") return tr_builds_comparison_columns_delta(inputs)
	if (locale === "cs") return cs_builds_comparison_columns_delta(inputs)
	if (locale === "bg") return bg_builds_comparison_columns_delta(inputs)
	if (locale === "ru") return ru_builds_comparison_columns_delta(inputs)
	if (locale === "uk") return uk_builds_comparison_columns_delta(inputs)
	if (locale === "ar") return ar_builds_comparison_columns_delta(inputs)
	if (locale === "hi") return hi_builds_comparison_columns_delta(inputs)
	if (locale === "th") return th_builds_comparison_columns_delta(inputs)
	if (locale === "ja") return ja_builds_comparison_columns_delta(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_columns_delta(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_columns_delta(inputs)
	return ko_builds_comparison_columns_delta(inputs)
});
export { builds_comparison_columns_delta as "builds.comparison.columns.delta" }